import coverBg from "../assets/brand/macet/cover-320x656.svg";
import styles from "./PassportCover.module.css";

interface Props {
  /** Passport serial — used for the aria-label only; not rendered visibly.
   *  The new Figma macet (3319:1085) shows the cover as a fully decorative
   *  card without a serial line; the number surfaces once the passport is
   *  issued (see <PassportBook />). */
  displayNumber: string;
  cityLabel?: string;
}

// Closed-book passport for the empty state. 1:1 copy of Figma frame
// 3319:1085 — the whole macet is baked into cover-640x1312.png so there
// are no runtime layout risks (jungle leaves, mask decorations, wordmark
// and inner card are pixel-perfect). Aspect-ratio 320/656 preserves the
// vertical mobile ratio; max-width caps growth on tablet-class widths.
export function PassportCover({ displayNumber, cityLabel }: Props) {
  const label = cityLabel
    ? `Паспорт искателя ${displayNumber}, ${cityLabel}, не активирован`
    : `Паспорт искателя ${displayNumber}, не активирован`;
  return (
    <div className={styles.cover} aria-label={label}>
      <img
        src={coverBg}
        alt=""
        aria-hidden
        className={styles.bg}
        draggable={false}
      />
    </div>
  );
}
